import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { CoPatronDetailComponent } from '../../components/co-patron-detail/co-patron-detail';
/**
 * Generated class for the CoRoamPatronlookupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-roam-patronlookup',
  templateUrl: 'co-roam-patronlookup.html',
  providers: [
    CoPatronDetailComponent
  ]
})
export class CoRoamPatronlookupPage {
  private selectedPatron: any = null;
  private results: Array<any> = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, private modal: ModalController) { }

  loadPatronDetails(index) {//TODO: MIGHT HAVE TO FIX THIS BY PUTTING IN THE PAGE
    this.selectedPatron = this.results[index];
    let modal = this.modal.create(CoPatronDetailComponent, { patron: this.selectedPatron });
    modal.present();
  }

  search() {
    // Have to hook up api

  }
}



// WEBPACK FOOTER //
// ./src/pages/co-roam-patronlookup/co-roam-patronlookup.ts